import React from 'react';

// Material UI
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

// Components
import CardDetail from './CardDetail';

const ObservationsDetails = ({ value, title, subTitle }) =>
  <CardDetail
    title={title}
    subTitle={subTitle}
    spacing={0}
    divider
  >
    <Grid container alignItems='center' justifyContent='space-between'>
      <Grid size={12}>
        {
          !!value &&
          <Typography variant='body1'>
            {value}
          </Typography>
        }
      </Grid>
    </Grid>
  </CardDetail>

export default ObservationsDetails;